/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionWaiverStagesMutation from '../graphql/mutations/SaveSouscriptionWaiverStagesMutation.js';

export const useSaveSouscriptionWaiverStagesMutation = () => {
  return useCommitMutation(SaveSouscriptionWaiverStagesMutation, {
    dataProp: 'saveSouscriptionWaiverStages_M_souscription_waiver_stages'
  });
};

export default useSaveSouscriptionWaiverStagesMutation;
